import { render } from "./TheTradePaymentMethods.vue?vue&type=template&id=4aac647a&scoped=true&ts=true"
import script from "./TheTradePaymentMethods.vue?vue&type=script&lang=ts"
export * from "./TheTradePaymentMethods.vue?vue&type=script&lang=ts"

import "./TheTradePaymentMethods.vue?vue&type=style&index=0&id=4aac647a&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aac647a"]])

export default __exports__